// Deployed Dev environment (dev branch, self-hosted agent copies the build here).
// REPLACE_ME: swap in the real dev API URL once known.
export const environment = {
  production: false,
  apiBaseUrl: 'https://REPLACE_ME-dev-api.example.com/api/v1'
};
